import { isAllowAction } from "../../../services/permissions/utils";
import { ModeratorResponse } from "../../../types/api/moderators";
import { getScoringTabTypeName, ScoringTabType } from "../../../types/api/scoring/scoring";
import { SegmentItem } from "../../../types/interfaces/navigation";

export const usersTabsData = (profile: ModeratorResponse | null) => {
    const usersAllow = isAllowAction(profile, 'VIEW_USERS')
    const appealsAllow = isAllowAction(profile, 'VIEW_USER_APPEALS')
    const suggestionsAllow = isAllowAction(profile, 'VIEW_USER_SUGGESTIONS')
    const complaintsAllow = isAllowAction(profile, 'VIEW_USER_COMPLAINTS')

    const items: SegmentItem[] = [
        ...(usersAllow) ? [{
            text: "Пользователи",
            href: "/users",
            isDisabled: false
        }] : [],
        ...(appealsAllow) ? [{
            text: "Обращения",
            href: "/users/appeals",
            isDisabled: false
        }] : [],
        ...(suggestionsAllow) ? [{
            text: "Предложения",
            href: "/users/suggestions",
            isDisabled: false
        }] : [],
        ...(complaintsAllow) ? [{
            text: "Жалобы",
            href: "/users/complaints",
            isDisabled: false
        }] : []
    ];

    return items
}

export const adsTabsData = (profile: ModeratorResponse | null, currentSearchParams?: URLSearchParams) => {
    const adsAllow = isAllowAction(profile, 'VIEW_ADS')

    const buildHref = (baseHref: string) => {
        if (!currentSearchParams) return baseHref

        const currentPathname = window.location.pathname
        const newParams = new URLSearchParams(currentSearchParams)

        // Сохранить некоторые query параметры
        currentSearchParams.forEach((value, key) => {
            if (key !== 'type') {
                newParams.set(key, value)
            }
        })

        const typeMatch = baseHref.match(/[?&]type=([^&]*)/);
        if (typeMatch) {
            newParams.set('type', typeMatch[1])
        }

        return `${currentPathname}?${newParams.toString()}`
    }

    const items: SegmentItem[] = [
        ...(adsAllow) ? [{
            text: "Размещенные",
            href: buildHref("/ads/?type=posted"),
            isDisabled: false
        }] : [],
        ...(adsAllow) ? [{
            text: "Требуют подтверждения",
            href: buildHref("/ads/?type=requiresConfirmation"),
            isDisabled: false
        }] : [],
        ...(adsAllow) ? [{
            text: "Архив",
            href: buildHref("/ads/?type=archive"),
            isDisabled: false
        }] : []
    ]

    return items
}

export const notificationsTabsData: SegmentItem[] = [
    {
        text: "Все",
        href: "/notifications/?type=all",
        isDisabled: false
    },
    {
        text: "Запланированные",
        href: "/notifications/?type=scheduled",
        isDisabled: false
    },
    {
        text: "Отправленные",
        href: "/notifications/?type=sended",
        isDisabled: false
    }
];

export const logsTabsData: SegmentItem[] = [
    {
        text: "Пользователи",
        href: "/logs/?type=users",
        isDisabled: false
    },
    {
        text: "Модераторы",
        href: "/logs/?type=moderators",
        isDisabled: false
    }
];

export const scoringTabsData: SegmentItem[] = [
    {
        text: getScoringTabTypeName(ScoringTabType.Users),
        href: `/scoring/?type=${ScoringTabType.Users}`,
        isDisabled: false
    },
    {
        text: getScoringTabTypeName(ScoringTabType.Categories),
        href: `/scoring/?type=${ScoringTabType.Categories}`,
        isDisabled: false
    },
    {
        text: getScoringTabTypeName(ScoringTabType.Catalogs),
        href: `/scoring/?type=${ScoringTabType.Catalogs}`,
        isDisabled: false
    },
    {
        text: getScoringTabTypeName(ScoringTabType.Segments),
        href: `/scoring/?type=${ScoringTabType.Segments}`,
        isDisabled: false
    }
];